package com.eladfinish.bible.contest.data

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class ChumashItem(
    @SerialName("chumash") val name: String,
    @SerialName("chapters") val chapters: Int,
    @SerialName("parashot") val parashot: List<ParashaItem>,
)

@Serializable
data class ParashaItem(
    @SerialName("name") val name: String,
    @SerialName("c1") val chapterStart: String,
    @SerialName("v1") val verseStart: String,
    @SerialName("c2") val chapterEnd: String,
    @SerialName("v2") val verseEnd: String,
    @SerialName("pair") val pair: Int? = null,
    @SerialName("הפטרה") val haftara: Map<String, List<String>>,
) {
    val start get() = "$chapterStart,$verseStart"
    val end get() = "$chapterEnd,$verseEnd"
    val source get() = "$start-$end"

    /**
     * The haftara sources for a tradition code. An entry holding a single one-letter source refers
     * to another tradition's haftara (e.g. Vezot Haberacha: Italian → Ashkenaz), which is resolved.
     */
    fun haftaraSources(tradition: String): List<String>? {
        val sources = haftara[tradition]
        return if (sources != null && sources.size == 1 && sources[0].length == 1) haftara[sources[0]] else sources
    }
}